import { Link } from "react-router-dom";

export const NotFound = () => {
  return (
    <section className="af-section" data-testid="not-found-page">
      <div className="af-container" style={{ maxWidth: 720 }}>
        <div className="af-eyebrow">404</div>
        <h1 className="af-h2" style={{ marginTop: 14, marginBottom: 18 }}>Page not found.</h1>
        <p className="af-lede" style={{ color: "#cfd3dc", marginBottom: 28 }}>
          The page you are looking for may have moved or does not exist.
        </p>
        <div>
          <Link to="/" className="af-btn af-btn-primary" data-testid="not-found-back-home">
            Back to Home
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
